import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=f3872744"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"
import style0 from "./Single.vue?vue&type=style&index=0&id=f3872744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports